var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisionLogo = function SvgVisionLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.345,
    height: 22.488
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Vision_logo_svg__a",
    x1: 0.36,
    y1: -78.736,
    x2: 1.204,
    y2: -80.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fc9dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51bec9"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "V logo Vision",
    d: "m7.376 21.488.907-4.517L11.733.7a.75.75 0 0 1 .8-.7h3.117q.83 0 .664.769l-5.146 20.017a.778.778 0 0 1-.8.7ZM.048.769Q-.185 0 .711 0h3.121a.752.752 0 0 1 .8.7L6.04 7.36l-1.886 9.385Z",
    transform: "translate(.502 .5)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    fill: "url(#Vision_logo_svg__a)"
  })));
};
export default SvgVisionLogo;